module.exports = __webpack_public_path__ + "img/4090.a0ae8861.jpg";